/*
  IK — Motore dell'assistente.

  Sta in un file a parte, e non dentro la sezione, per due motivi:
  il browser lo mette in cache una volta sola invece di riscaricarlo e
  rianalizzarlo su ogni pagina del sito; e si puo' correggere senza
  toccare il markup.

  I DATI non stanno qui: arrivano dal blocco JSON che la sezione stampa
  sulla pagina (metacampi Negozio, prodotto in corso, pagamenti) e dalle
  risposte scritte a mano nei blocchi della sezione. Questo file
  contiene solo la LOGICA: come si capisce la domanda, e quale risposta
  vera si sceglie.

  IL CATALOGO ARRIVA DOPO. Prima veniva stampato nell'HTML di ogni
  pagina del sito: circa 5,6 KB e un ciclo su 50 prodotti pagati anche
  da chi il pannello non lo apre mai, cioe' quasi tutti. Adesso si
  scarica una volta sola alla PRIMA APERTURA, dalla sezione dedicata
  ik-assistant-data (vedi caricaDati piu' sotto). Finche' non e'
  arrivato, le ricerche sul catalogo non trovano nulla: per questo
  chiedi() aspetta caricaDati() prima di rispondere.

  Vedi sections/ik-assistant.liquid per il perche' delle scelte.
*/
(function () {
  var root = document.querySelector('[data-ik-as]');
  if (!root) { return; }

  var dataEl = root.querySelector('[data-ik-as-data]');
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var stream = root.querySelector('[data-ik-as-stream]');
  var form = root.querySelector('[data-ik-as-form]');
  var input = root.querySelector('[data-ik-as-input]');
  var openBtn = root.querySelector('[data-ik-as-open]');
  var closeBtn = root.querySelector('[data-ik-as-close]');

  function push(nome, payload) {
    if (typeof window.ikPush === 'function') { window.ikPush(nome, payload || {}); }
  }

  /* ---------------------------------------------------------------
     1. LINGUA — parole vuote, sinonimi, radici, somiglianza
     --------------------------------------------------------------- */

  var STOP = ('a ad ai al all alla alle allo agli anche c ce ci co col con cosi cui da dal dalla dalle dallo degli dei del della delle dello di e ed gli ha hai hanno ho i il in io la le lei li lo loro ma me mi mia mie miei mio ne negli nei nel nella nelle nello no noi non o od per piu po qua qual quel quella quelle quello questa queste questi questo qui se sei si sia siamo siete sono su sui sul sulla sulle sullo te ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostro ok ciao salve buongiorno buonasera grazie prego mah boh vorrei volevo sapere dire dirmi posso possiamo puoi potete potrei riesco riesci').split(' ');

  var SIN = {
    congelare: 'congelare congelo congelarlo congelarla congelato congelata freezer surgelare surgelato surgelata ricongelare congelamento',
    scadenza: 'scadenza scade scaduto scadono dura durano durata giorni conservazione conservare conservarlo conservo frigo frigorifero shelf mantiene',
    consegna: 'consegna consegne consegnare consegnano arriva arrivano arrivo arrivare arrivera ricevo ricevete ricevere riceverlo spedite spediscono corriere spedito spedizione partenza parte partono tracking data quando tempi tempo attesa sabato domenica weekend',
    costosped: 'spedizione spedizioni porto trasporto gratis gratuita gratuito soglia franco',
    allergeni: 'allergeni allergene allergia allergico allergica celiaco celiaci celiachia glutine senza glutine soia lattosio latte uova frutta guscio arachidi pistacchio sesamo intolleranza intollerante',
    preparazione: 'preparare prepara preparo prepari preparazione scaldare scalda scaldo scaldi riscaldare riscalda riscaldano scaldano scaldarlo scaldarli cuocere cuoce cuoci cuociono cottura cuocerlo forno padella friggitrice aria microonde rigenerare rigenerazione minuti gradi temperatura ricetta cucinare',
    ingredienti: 'ingredienti ingrediente contiene composizione dentro etichetta conservanti coloranti additivi',
    prezzo: 'prezzo prezzi costa costo costano euro viene spendere',
    vegetale: 'vegano vegana vegani vegetariano vegetariana vegetale veg plant based',
    box: 'box comporre componi comporla mix assortita assortito assortimento cassetta selezione',
    reso: 'reso resi rimborso rimborsare danneggiato rotto rovinato caldo sciolto reclamo sostituzione garanzia problema',
    ordine: 'ordine ordini ordinare ordinato modificare annullare cancellare cambiare aggiungere',
    regalo: 'regalo regalare regalarlo destinatario biglietto dedica sorpresa',
    disponibile: 'disponibile disponibilita disponibili esaurito esauriti esaurita scorte stock torna rifornimento comprare acquistare',
    freschezza: 'fresco freschi surgelato congelato refrigerato abbattuto abbattimento temperatura catena freddo ghiaccio ghiacciato ghiacciata',
    produzione: 'produce producete produzione laboratorio artigianale fatto mano dove chi siete azienda sicilia',
    carrello: 'carrello ordine totale mancano manca raggiungere soglia',
    contatti: 'contatto contatti contattare parlare persona umano operatore telefono email scrivere whatsapp assistenza aiuto'
  };

  /* Radice di sei lettere: "scaldano" e "scaldare" finiscono sullo stesso
     gruppo. Se due gruppi diversi si contendono la stessa radice, la radice
     si butta: meglio nessuna etichetta che l'etichetta sbagliata. */
  var SINMAP = {};
  var RADICI = {};
  Object.keys(SIN).forEach(function (k) {
    SIN[k].split(' ').forEach(function (w) {
      if (!w) { return; }
      SINMAP[w] = k;
      if (w.length >= 6) {
        var r = w.slice(0, 6);
        if (RADICI[r] === undefined) { RADICI[r] = k; }
        else if (RADICI[r] !== k) { RADICI[r] = null; }
      }
    });
  });

  function norm(s) {
    var t = (s === null || s === undefined) ? '' : String(s);
    t = t.toLowerCase();
    if (t.normalize) { t = t.normalize('NFD').replace(/[̀-ͯ]/g, ''); }
    return t.replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function toks(s) {
    var out = [];
    norm(s).split(' ').forEach(function (w) {
      if (!w || w.length < 2) { return; }
      if (STOP.indexOf(w) > -1) { return; }
      out.push(w);
    });
    return out;
  }

  function expand(list) {
    var out = list.slice();
    list.forEach(function (w) {
      var c = SINMAP[w];
      if (!c && w.length >= 6) { c = RADICI[w.slice(0, 6)] || null; }
      if (c && out.indexOf('#' + c) === -1) { out.push('#' + c); }
    });
    return out;
  }

  function bigr(s) {
    var a = [];
    for (var i = 0; i < s.length - 1; i++) { a.push(s.substr(i, 2)); }
    return a;
  }

  function dice(a, b) {
    if (a === b) { return 1; }
    if (a.length < 4 || b.length < 4) { return 0; }
    var A = bigr(a), B = bigr(b), copy = B.slice(), hit = 0;
    for (var i = 0; i < A.length; i++) {
      var j = copy.indexOf(A[i]);
      if (j > -1) { hit++; copy.splice(j, 1); }
    }
    return (2 * hit) / (A.length + B.length);
  }

  /* ---------------------------------------------------------------
     2. DATI VIVI — la data di consegna, il carrello, questo piatto
     --------------------------------------------------------------- */

  var GG = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
  var MM = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];

  function feriale(d) { var g = d.getDay(); return g !== 0 && g !== 6; }

  function piuGiorni(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() + 1); if (feriale(r)) { n--; } }
    return r;
  }

  function giorno(d) { return GG[d.getDay()] + ' ' + d.getDate(); }

  function eta() {
    var S = D.spedizione;
    var ora = new Date();
    var parteOggi = S.giorni_num.indexOf(ora.getDay()) !== -1 && ora.getHours() < S.taglio;
    var sped = new Date(ora.getFullYear(), ora.getMonth(), ora.getDate());
    if (!parteOggi) {
      for (var i = 0; i < 10; i++) {
        sped.setDate(sped.getDate() + 1);
        if (S.giorni_num.indexOf(sped.getDay()) !== -1) { break; }
      }
    }
    var da = piuGiorni(sped, S.transito_min);
    var a = piuGiorni(sped, S.transito_max);
    var finestra;
    if (da.getTime() === a.getTime()) {
      finestra = giorno(da) + ' ' + MM[da.getMonth()];
    } else if (da.getMonth() === a.getMonth()) {
      finestra = 'tra ' + giorno(da) + ' e ' + giorno(a) + ' ' + MM[a.getMonth()];
    } else {
      finestra = 'tra ' + giorno(da) + ' ' + MM[da.getMonth()] + ' e ' + giorno(a) + ' ' + MM[a.getMonth()];
    }
    return { parteOggi: parteOggi, partenza: giorno(sped) + ' ' + MM[sped.getMonth()], finestra: finestra, taglio: S.taglio };
  }

  var CART = null;
  function caricaCarrello() {
    if (CART) { return Promise.resolve(CART); }
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { CART = c; return c; })
      .catch(function () { return null; });
  }

  function soldi(cent) {
    try { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; } catch (e) { return ''; }
  }

  function campoProdotto(nome) {
    var box = root.querySelector('[data-ik-as-prod]');
    if (!box) { return ''; }
    var el = box.querySelector('[data-f="' + nome + '"]');
    return el ? el.innerHTML.trim() : '';
  }

  /* ---------------------------------------------------------------
     3. LA BASE DI CONOSCENZA
        - voci vive: si ricalcolano a ogni domanda
        - voci scritte: i blocchi della sezione
     --------------------------------------------------------------- */

  var S = D.spedizione;
  var N = D.negozio;
  var P = D.prodotto;
  var KB = [];

  function voce(o) {
    o.qt = expand(toks(o.q));
    o.kt = expand(toks(o.keys || ''));
    o.bt = expand(toks((o.body || '').replace(/<[^>]+>/g, ' ')));
    o.nq = norm(o.q);
    KB.push(o);
  }

  /* --- vive ---------------------------------------------------- */

  voce({
    id: 'live_consegna',
    q: 'Quando mi arriva se ordino adesso?',
    keys: 'quando arriva consegna ricevo ordine tempi spedizione partenza corriere data giorni sabato domenica weekend scegliere quanto ci mette',
    boost: 0.16,
    fn: function () {
      var e = eta();
      var h = '<p>Se ordini adesso lo ricevi <strong>' + e.finestra + '</strong>.</p>';
      if (e.parteOggi) {
        h += '<p>Parte oggi se completi l’ordine entro le <strong>' + e.taglio + ':00</strong>.</p>';
      } else {
        h += '<p>Prima partenza utile: <strong>' + e.partenza + '</strong>. Partiamo ' + S.giorni + ', così il cibo non resta fermo in deposito nel weekend.</p>';
      }
      h += '<p>Il viaggio dura ' + S.viaggio + ' lavorative, con tracking su ogni ordine.</p>';
      return h;
    }
  });

  voce({
    id: 'live_spedizione',
    q: 'Quanto costa la spedizione?',
    keys: 'spedizione costo costa gratis gratuita soglia porto trasporto estero germania francia europa quanto',
    boost: 0.12,
    fn: function () {
      var h = '<p><strong>' + S.costo + '</strong> ' + S.area + ', <strong>gratuita da ' + S.soglia + '</strong>.</p>';
      if (S.eu_on || S.mondo_on) {
        h += '<p>Fuori dall’Italia:' + (S.eu_on ? ' Germania e Francia ' + S.eu + ';' : '') + (S.mondo_on ? ' elenco ristretto di paesi extra-UE ' + S.mondo + '.' : '') + '</p>';
      }
      h += '<p>Il costo esatto compare alla cassa in base alla destinazione: è lo stesso numero che vedi qui.</p>';
      return h;
    }
  });

  voce({
    id: 'live_carrello',
    q: 'Quanto mi manca alla spedizione gratuita?',
    keys: 'carrello totale mancano manca raggiungere quanto ancora spendere',
    boost: 0.1,
    fn: function () {
      if (!CART) { return null; }
      if (!CART.item_count) {
        return '<p>Il carrello è ancora vuoto. La spedizione diventa gratuita da <strong>' + S.soglia + '</strong>.</p>';
      }
      var manca = S.soglia_cent - CART.total_price;
      if (manca <= 0) {
        return '<p>Ci sei: hai <strong>' + soldi(CART.total_price) + '</strong> nel carrello, quindi la <strong>spedizione è gratuita</strong>.</p>';
      }
      return '<p>Nel carrello hai <strong>' + soldi(CART.total_price) + '</strong>: ti mancano <strong>' + soldi(manca) + '</strong> alla spedizione gratuita.</p>' +
             '<p>Aggiungere un piatto non costa un secondo trasporto: parte tutto nello stesso pacco.</p>';
    }
  });

  if (P) {
    voce({
      id: 'live_prezzo',
      q: 'Quanto costa questo piatto?',
      keys: 'prezzo costa costo euro quanto viene questo piatto',
      boost: 0.18,
      fn: function () {
        var h = '<p><strong>' + P.titolo + '</strong> costa <strong>' + P.prezzo + '</strong>';
        if (P.porzioni) { h += ' (' + P.porzioni + ')'; }
        h += '.</p>';
        h += P.disponibile
          ? '<p>È disponibile adesso. Spedizione gratuita da ' + S.soglia + '.</p>'
          : '<p>In questo momento è <strong>esaurito</strong>: viene rifatto in laboratorio, non ristampato da un magazzino.</p>';
        return h;
      }
    });

    voce({
      id: 'live_disponibile',
      q: 'È disponibile? Quando torna?',
      keys: 'disponibile disponibilita esaurito scorte quando torna stock rifornimento comprare',
      boost: 0.1,
      fn: function () {
        return P.disponibile
          ? '<p>Sì, <strong>' + P.titolo + '</strong> è disponibile adesso.</p>'
          : '<p><strong>' + P.titolo + '</strong> è esaurito. È produzione artigianale su ordine: quando finisce servono giorni per rifarlo.</p><p>Scrivici e ti avvisiamo appena rientra.</p>';
      }
    });

    voce({
      id: 'live_formato',
      q: 'Quanto pesa e per quante persone è?',
      keys: 'peso pesa grammi porzioni persone quante quanti pezzi formato basta abbondante tempo pronto minuti',
      boost: 0.12,
      fn: function () {
        var righe = [];
        if (P.formato) { righe.push('<li><strong>Formato:</strong> ' + P.formato + '</li>'); }
        if (P.porzioni) { righe.push('<li><strong>Porzioni:</strong> ' + P.porzioni + '</li>'); }
        if (P.peso) { righe.push('<li><strong>Peso netto:</strong> ' + P.peso + '</li>'); }
        if (P.tempo) { righe.push('<li><strong>' + P.tempo + '</strong></li>'); }
        if (!righe.length) { return null; }
        return '<p><strong>' + P.titolo + '</strong></p><ul>' + righe.join('') + '</ul>';
      },
      src: { label: 'Scheda tecnica completa', url: P.url + '#shopify-section-ik_details' }
    });

    var mapProd = [
      ['live_scadenza', 'Quanto dura questo piatto?', 'scadenza dura durata giorni conservazione quanto tempo frigo', 'scadenza', 'Quanto dura'],
      ['live_conserva', 'Come si conserva?', 'conservare conservazione frigo frigorifero temperatura dove metto', 'conservazione', 'Come si conserva'],
      ['live_prepara', 'Come si prepara questo piatto?', 'preparare scaldare riscaldare cuocere forno padella friggitrice minuti rigenerare come si fa', 'preparazione', 'Come si prepara'],
      ['live_ingr', 'Cosa c’è dentro?', 'ingredienti contiene composizione dentro cosa cè', 'ingredienti', 'Ingredienti'],
      ['live_all', 'Quali allergeni contiene?', 'allergeni allergia celiaco glutine soia lattosio frutta a guscio intolleranza', 'allergeni', 'Allergeni'],
      ['live_cont', 'Cosa contiene la confezione?', 'contiene confezione pezzi quanti porzioni quantita', 'contenuto', 'Nella confezione'],
      ['live_valori', 'Quante calorie ha?', 'calorie kcal valori nutrizionali proteine grassi carboidrati zuccheri sale tabella nutrizione dieta', 'valori', 'Valori nutrizionali']
    ];

    mapProd.forEach(function (m) {
      voce({
        id: m[0],
        q: m[1],
        keys: m[2],
        boost: 0.14,
        fn: function () {
          var v = campoProdotto(m[3]);
          if (!v) {
            if (m[3] === 'ingredienti') {
              return '<p>La lista completa degli ingredienti di <strong>' + P.titolo + '</strong> è stampata sull’etichetta della confezione.</p>' +
                     '<p>Su questa pagina non è ancora riportata: se ti serve <em>prima</em> di ordinare chiedicela, te la mandiamo per intero.</p>';
            }
            if (m[3] === 'allergeni') {
              return '<p>Gli allergeni di <strong>' + P.titolo + '</strong> sono stampati sull’etichetta della confezione, ma su questa pagina non sono ancora riportati.</p>' +
                     '<p>Due cose vere per tutta la linea: il <strong>seitan è glutine di frumento</strong>, quindi i burger di seitan non sono adatti ai celiaci; alcune alternative vegetali ai formaggi sono <strong>a base di soia</strong>.</p>' +
                     '<p>Se hai un’allergia, chiedici l’elenco esatto <em>prima</em> di ordinare: non voglio fartelo indovinare.</p>';
            }
            return null;
          }
          var h = '<p><strong>' + m[4] + ' — ' + P.titolo + '</strong></p>' + v;
          if (m[3] === 'scadenza') { h += '<p>La data esatta è stampata sulla confezione: è quella che fa fede.</p>'; }
          if (m[3] === 'allergeni') { h += '<p>Gli allergeni sono stampati anche sulla confezione. Se hai un’allergia grave, scrivici <em>prima</em> di ordinare.</p>'; }
          return h;
        },
        hand: (m[3] === 'allergeni' || m[3] === 'ingredienti') && !campoProdotto(m[3]),
        src: { label: 'Scheda tecnica completa', url: P.url + '#shopify-section-ik_details' }
      });
    });
  }

  if (P && P.temperatura) {
    voce({
      id: 'live_arrivo',
      q: 'Come arriva? Congelato o fresco?',
      keys: 'come arriva congelato surgelato fresco refrigerato freddo ghiaccio temperatura stato imballo scatola pacco',
      boost: 0.14,
      fn: function () {
        var h = '<p><strong>' + P.titolo + '</strong> arriva <strong>' + P.temperatura.toLowerCase() + '</strong>.</p>';
        h += '<p>Viaggia in scatola isotermica con piastre eutettiche: lo metti in frigorifero appena lo ricevi. È già cotto, non c’è niente da scongelare.</p>';
        var cons = campoProdotto('conservazione');
        if (cons) { h += cons; }
        return h;
      },
      src: { label: 'Scheda tecnica completa', url: P.url + '#shopify-section-ik_details' }
    });
  }

  voce({
    id: 'live_pagamento',
    q: 'Come posso pagare?',
    keys: 'pagare pagamento pagamenti carta credito bancomat paypal contrassegno contanti alla consegna satispay klarna rateale metodi',
    boost: 0.12,
    fn: function () {
      var nomi = {
        visa: 'Visa', master: 'Mastercard', american_express: 'American Express', maestro: 'Maestro',
        paypal: 'PayPal', apple_pay: 'Apple Pay', google_pay: 'Google Pay', shopify_pay: 'Shop Pay',
        bancontact: 'Bancontact', jcb: 'JCB', diners_club: 'Diners Club', discover: 'Discover',
        klarna: 'Klarna', ideal: 'iDEAL', sofort: 'Sofort', bitcoin: 'Bitcoin', dogecoin: 'Dogecoin', litecoin: 'Litecoin'
      };
      var lista = (D.pagamenti || []).map(function (t) { return nomi[t] || t; });
      if (!lista.length) { return null; }
      return '<p>Alla cassa trovi: <strong>' + lista.join(', ') + '</strong>.</p>' +
             '<p>Sono i metodi attivi in questo momento: quello che vedi qui è quello che troverai al pagamento.</p>';
    }
  });

  voce({
    id: 'live_paesi',
    q: 'Dove spedite? Spedite all’estero?',
    keys: 'dove spedite estero fuori italia europa mondo internazionale svizzera austria spagna belgio isole sicilia sardegna calabria paesi nazioni',
    boost: 0.12,
    fn: function () {
      var h = '<p>Spediamo <strong>' + S.paesi + '</strong>.</p>';
      h += '<p>' + S.costo + ' ' + S.area + ' (gratuita da ' + S.soglia + ')';
      if (S.eu_on) { h += '; Germania e Francia ' + S.eu; }
      if (S.mondo_on) { h += '; paesi extra-UE ' + S.mondo; }
      h += '.</p>';
      h += '<p>Se il tuo paese non compare alla cassa, vuol dire che per ora non ci arriviamo: scrivici e ti diciamo se possiamo farlo.</p>';
      return h;
    }
  });

  voce({
    id: 'live_contatti',
    q: 'Voglio parlare con una persona',
    keys: 'contatto contattare parlare persona umano operatore telefono email scrivere whatsapp assistenza aiuto',
    boost: 0.08,
    fn: function () {
      return '<p>Volentieri. Ti rispondiamo di persona, di solito entro poche ore.</p>';
    },
    hand: true
  });

  /* --- scritte dal negozio -------------------------------------- */

  var srcBox = root.querySelector('[data-ik-as-src]');
  if (srcBox) {
    Array.prototype.forEach.call(srcBox.querySelectorAll('article'), function (a) {
      voce({
        id: a.getAttribute('data-id'),
        q: a.getAttribute('data-q') || '',
        cat: a.getAttribute('data-cat') || '',
        keys: a.getAttribute('data-k') || '',
        body: a.innerHTML,
        boost: 0
      });
    });
  }

  /* --- catalogo: "quanto costa Boss Fight", "avete arancini" -----

     Queste tre strutture nascono VUOTE e vengono riempite da
     indicizzaCatalogo() quando il catalogo arriva (vedi caricaDati).
     Sono dichiarate con var nello stesso ambito delle funzioni che le
     leggono, quindi riassegnarle basta: cercaProdotti e cercaTipo
     vedono subito i dati nuovi.
     Con le strutture vuote nessuna ricerca sul catalogo trova niente e
     l'assistente non sbaglia risposta: si limita a non riconoscere i
     nomi dei piatti. Per questo chiedi() aspetta caricaDati(). */

  var CAT = [];
  var DF = {};
  var TIPI = {};

  function indicizzaCatalogo(lista) {
    CAT = (lista || []).filter(function (p) { return p && p.t; });
    DF = {};
    TIPI = {};
    CAT.forEach(function (p) {
      p.tt = toks(p.t);
      var visti = {};
      p.tt.forEach(function (w) { if (!visti[w]) { visti[w] = 1; DF[w] = (DF[w] || 0) + 1; } });
      if (!p.y) { return; }
      var k = norm(p.y);
      if (!TIPI[k]) { TIPI[k] = { nome: p.y, tok: toks(p.y), items: [] }; }
      TIPI[k].items.push(p);
    });
  }

  /* Compatibilita' all'indietro: se una versione precedente della
     sezione stampa ancora il catalogo dentro la pagina, si usa quello e
     non si scarica niente. */
  if (D.catalogo && D.catalogo.length) { indicizzaCatalogo(D.catalogo); }

  /* I DATI PESANTI, CHIESTI UNA VOLTA SOLA ALLA PRIMA APERTURA.
     La sezione ik-assistant-data non sta in nessun template: si chiede
     via Section Rendering API. Cosi' il catalogo non pesa sull'HTML di
     tutte le pagine del sito, ma solo su chi apre davvero l'assistente.
     La promessa e' tenuta da parte: le aperture successive, e le domande
     fatte mentre il catalogo sta ancora arrivando, aspettano la stessa
     richiesta invece di farne un'altra.
     Se la richiesta fallisce l'assistente NON si rompe: perde solo la
     ricerca per nome di piatto, tutto il resto (consegna, spedizione,
     conservazione, allergeni, Q&A) continua a rispondere. */

  var datiPromise = null;

  function caricaDati() {
    if (datiPromise) { return datiPromise; }
    if (CAT.length) { datiPromise = Promise.resolve(true); return datiPromise; }

    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    datiPromise = fetch(base + '?section_id=ik-assistant-data', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) { return false; }
        var cassa = document.createElement('div');
        cassa.className = 'ik-as__src-hidden';
        cassa.setAttribute('data-ik-as-dati', '');
        cassa.hidden = true;
        cassa.innerHTML = html;
        root.appendChild(cassa);
        var js = cassa.querySelector('[data-ik-as-cat]');
        if (!js) { return false; }
        try { indicizzaCatalogo(JSON.parse(js.textContent)); } catch (e) { return false; }
        return true;
      })
      .catch(function () { return false; });

    return datiPromise;
  }

  function rariDelCatalogo(qt) {
    var lim = Math.max(1, Math.round(CAT.length * 0.34));
    var chiavi = Object.keys(DF);
    return qt.filter(function (w) {
      if (w.charAt(0) === '#' || w.length < 4) { return false; }
      for (var i = 0; i < chiavi.length; i++) {
        var k = chiavi[i];
        if ((k === w || dice(k, w) >= 0.78) && DF[k] <= lim) { return true; }
      }
      return false;
    });
  }

  function cercaProdotti(qt) {
    var out = [];
    CAT.forEach(function (p) {
      var punti = 0, forti = 0;
      qt.forEach(function (w) {
        if (w.charAt(0) === '#') { return; }
        var best = 0;
        p.tt.forEach(function (t) {
          var s = (t === w) ? 1 : dice(t, w);
          if (s > best) { best = s; }
        });
        if (best >= 0.78) {
          var raro = 1 - Math.min(0.7, (DF[w] || 1) / Math.max(4, CAT.length));
          punti += best * raro;
          if (w.length >= 4) { forti++; }
        }
      });
      if (forti > 0) { out.push({ p: p, s: punti / Math.max(2, p.tt.length * 0.6) }); }
    });
    out.sort(function (a, b) { return b.s - a.s; });
    return out;
  }

  function schedaProdotti(lista) {
    if (lista.length === 1) {
      var p = lista[0].p;
      var h = '<p><strong>' + p.t + '</strong> — ' + p.p + '</p>';
      h += p.d ? '<p>Disponibile adesso.</p>' : '<p>In questo momento è <strong>esaurito</strong>.</p>';
      h += '<p><a href="' + p.u + '">Apri la scheda del piatto</a></p>';
      return h;
    }
    var l = '<p>Ne trovo ' + lista.length + '. Questi sono i più vicini a quello che hai chiesto:</p><ul>';
    lista.slice(0, 5).forEach(function (x) {
      l += '<li><a href="' + x.p.u + '">' + x.p.t + '</a> — ' + x.p.p + (x.p.d ? '' : ' (esaurito)') + '</li>';
    });
    return l + '</ul>';
  }

  function cercaTipo(qt) {
    var best = null;
    Object.keys(TIPI).forEach(function (k) {
      TIPI[k].tok.forEach(function (t) {
        qt.forEach(function (w) {
          if (w.charAt(0) === '#' || w.length < 3) { return; }
          var sc = (t === w) ? 1 : dice(t, w);
          if (sc >= 0.8 && (!best || sc > best.s)) { best = { s: sc, tipo: TIPI[k], parola: w }; }
        });
      });
    });
    return best;
  }

  function schedaTipo(t) {
    var disp = t.items.filter(function (x) { return x.d; });
    var lista = (disp.length ? disp : t.items);
    var mostra = lista.slice(0, 6);
    var h = '<p>Sì. In <strong>' + t.nome + '</strong> ' + (disp.length ? 'adesso trovi' : 'abbiamo') + ' ' + lista.length + (lista.length === 1 ? ' piatto' : ' piatti') + (disp.length ? '' : ', al momento tutti esauriti') + ':</p><ul>';
    mostra.forEach(function (x) {
      h += '<li><a href="' + x.u + '">' + x.t + '</a> — ' + x.p + (x.d ? '' : ' (esaurito)') + '</li>';
    });
    h += '</ul>';
    if (lista.length > mostra.length) { h += '<p>E altri ' + (lista.length - mostra.length) + '. <a href="/collections/all">Vedi tutto</a></p>'; }
    return h;
  }

  /* ---------------------------------------------------------------
     4. IL MOTORE — capisce la domanda, non inventa la risposta
     --------------------------------------------------------------- */

  function punteggio(v, qt) {
    if (!qt.length) { return 0; }
    var tot = 0;
    qt.forEach(function (w) {
      var p = 0;
      if (v.qt.indexOf(w) > -1) { p = 1; }
      else if (v.kt.indexOf(w) > -1) { p = 0.85; }
      else if (v.bt.indexOf(w) > -1) { p = 0.3; }
      else if (w.charAt(0) !== '#') {
        var best = 0;
        v.qt.concat(v.kt).forEach(function (t) {
          if (t.charAt(0) === '#') { return; }
          var s = dice(t, w);
          if (s > best) { best = s; }
        });
        if (best >= 0.74) { p = 0.62 * best; }
      }
      tot += p;
    });
    var s = tot / qt.length;
    if (v.nq && v.nq.length > 6) {
      var nq = norm(ULTIMA);
      if (nq.length > 6 && (v.nq.indexOf(nq) > -1 || nq.indexOf(v.nq) > -1)) { s += 0.3; }
    }
    return s + (v.boost || 0);
  }

  var ULTIMA = '';

  function classifica(domanda) {
    ULTIMA = domanda;
    var qt = expand(toks(domanda));
    var voci = KB.map(function (v) { return { v: v, s: punteggio(v, qt) }; })
      .sort(function (a, b) { return b.s - a.s; });
    return { qt: qt, voci: voci, prod: cercaProdotti(qt) };
  }

  function decidi(r) {
    var top = r.voci[0];
    var prod = r.prod.length ? r.prod[0] : null;
    var risposta = null, usata = null;

    /* La domanda e' su un tema (conservazione, cottura, allergeni...)
       oppure sul piatto in se' (prezzo, disponibilita', "avete X")? */
    var TOPICI = ['#scadenza', '#preparazione', '#allergeni', '#ingredienti', '#congelare', '#consegna', '#costosped', '#reso', '#ordine', '#regalo', '#carrello', '#produzione', '#freschezza', '#contatti', '#box', '#vegetale'];
    var suDiLui = r.qt.indexOf('#prezzo') > -1 || r.qt.indexOf('#disponibile') > -1;
    var suUnTema = r.qt.some(function (t) { return TOPICI.indexOf(t) > -1; });
    var libero = suDiLui || !suUnTema;

    /* 1. Ha nominato un piatto preciso e la risposta migliore non sa cosa sia. */
    var noti = top ? top.v.qt.concat(top.v.kt) : [];
    var scoperti = prod ? rariDelCatalogo(r.qt).filter(function (w) { return noti.indexOf(w) === -1; }) : [];
    if (prod && libero && prod.s >= 0.3 && (prod.s >= 0.45 || scoperti.length)) {
      var vicini = r.prod.filter(function (x) { return x.s >= prod.s * 0.7; }).slice(0, 5);
      return { risposta: schedaProdotti(vicini), usata: { id: 'catalogo' }, top: top, prod: prod };
    }

    /* 2. Ha nominato una categoria: "avete arancini", "fate i calzoni".
       Non scatta se sta chiedendo del piatto che ha davanti, a meno che non
       stia proprio guardandosi intorno ("avete", "quali", "altri"). */
    var CUE = ['avete', 'fate', 'quali', 'quanti', 'quante', 'altri', 'altre', 'tutti', 'tutte', 'elenco', 'lista', 'esistono', 'trovo', 'vendete', 'offrite', 'disponibili'];
    var haCue = r.qt.some(function (w) { return CUE.indexOf(w) > -1; });
    var tipo = cercaTipo(r.qt);
    var suoTipo = (P && P.tipo) ? norm(P.tipo) : '';
    var stessoTipo = tipo && suoTipo && norm(tipo.tipo.nome) === suoTipo;
    if (tipo && libero && (haCue || !stessoTipo) && (haCue || !top || noti.indexOf(tipo.parola) === -1)) {
      return { risposta: schedaTipo(tipo.tipo), usata: { id: 'categoria' }, top: top, prod: prod };
    }

    /* 3. La risposta migliore. */
    if (top && top.s >= 0.34) {
      var html = top.v.fn ? top.v.fn() : top.v.body;
      if (html) { risposta = html; usata = top.v; }
    }

    /* 4. Se quella non ha materiale (un dato non ancora compilato), la successiva. */
    if (!risposta && top && top.s >= 0.34) {
      for (var i = 1; i < r.voci.length; i++) {
        if (r.voci[i].s < 0.28) { break; }
        var c = r.voci[i].v;
        var hh = c.fn ? c.fn() : c.body;
        if (hh) { risposta = hh; usata = c; break; }
      }
    }

    return { risposta: risposta, usata: usata, top: top, prod: prod };
  }

  /* ---------------------------------------------------------------
     5. LA CONVERSAZIONE
     --------------------------------------------------------------- */

  function bolla(html, mia) {
    var wrap = document.createElement('div');
    wrap.className = 'ik-as__msg' + (mia ? ' is-me' : '');
    var b = document.createElement('div');
    b.className = 'ik-as__bubble';
    if (mia) { b.textContent = html; } else { b.innerHTML = html; }
    wrap.appendChild(b);
    stream.appendChild(wrap);
    stream.scrollTop = stream.scrollHeight;
    return b;
  }

  function fonte(b, src) {
    if (!src || !src.url) { return; }
    var s = document.createElement('span');
    s.className = 'ik-as__src';
    s.innerHTML = 'Fonte: <a href="' + src.url + '">' + src.label + '</a>';
    b.appendChild(s);
  }

  function scegliSeguiti(r, usata) {
    var visti = {};
    if (usata && usata.q) { visti[norm(usata.q)] = 1; }
    var out = [];
    for (var i = 0; i < r.voci.length && out.length < 3; i++) {
      var x = r.voci[i];
      if (x.s <= 0.12 || x.v === usata) { continue; }
      var chiave = norm(x.v.q);
      if (!chiave || visti[chiave]) { continue; }
      if (x.v.fn ? !x.v.fn() : !x.v.body) { continue; }
      visti[chiave] = 1;
      out.push(x.v.q);
    }
    return out;
  }

  function suggerimenti(lista) {
    if (!lista.length) { return; }
    var box = document.createElement('div');
    box.className = 'ik-as__sugg';
    lista.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = t;
      b.addEventListener('click', function () { chiedi(t, 'suggerimento'); });
      box.appendChild(b);
    });
    stream.appendChild(box);
    stream.scrollTop = stream.scrollHeight;
  }

  function passaggio(domanda) {
    var box = document.createElement('div');
    box.className = 'ik-as__hand';
    var testo = encodeURIComponent('Ciao! Domanda dal sito: ' + domanda);
    if (N.whatsapp) {
      var w = document.createElement('a');
      w.href = 'https://wa.me/' + N.whatsapp + '?text=' + testo;
      w.target = '_blank';
      w.rel = 'noopener';
      w.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2zm5.6 14.2c-.2.7-1.3 1.3-1.9 1.4-.5.1-1.1.1-1.8-.1-.4-.1-1-.3-1.7-.6-3-1.3-4.9-4.3-5-4.5-.2-.2-1.2-1.6-1.2-3s.7-2.1 1-2.4c.3-.3.6-.4.8-.4h.6c.2 0 .4 0 .6.5l.9 2.1c.1.2.1.4 0 .6l-.4.5-.3.3c-.1.1-.2.3 0 .5.2.3.8 1.3 1.7 2.1 1.1 1 2 1.3 2.3 1.4.2.1.4.1.5-.1l.8-.9c.2-.2.3-.2.5-.1l2 1c.2.1.4.2.4.3.1.1.1.6-.1 1.3z"/></svg>WhatsApp';
      w.addEventListener('click', function () { push('assistant_handoff', { canale: 'whatsapp', domanda: domanda }); });
      box.appendChild(w);
    }
    if (N.email) {
      var m = document.createElement('a');
      m.className = N.whatsapp ? 'alt' : '';
      m.href = 'mailto:' + N.email + '?subject=' + encodeURIComponent('Domanda dal sito') + '&body=' + testo;
      m.textContent = 'Scrivici una mail';
      m.addEventListener('click', function () { push('assistant_handoff', { canale: 'email', domanda: domanda }); });
      box.appendChild(m);
    } else if (N.contatti) {
      var c = document.createElement('a');
      c.className = N.whatsapp ? 'alt' : '';
      c.href = N.contatti;
      c.textContent = 'Scrivici';
      c.addEventListener('click', function () { push('assistant_handoff', { canale: 'contatti', domanda: domanda }); });
      box.appendChild(c);
    }
    if (box.children.length) {
      stream.appendChild(box);
      stream.scrollTop = stream.scrollHeight;
    }
  }

  var pensa = null;
  function scrivendo() {
    var wrap = document.createElement('div');
    wrap.className = 'ik-as__msg';
    wrap.innerHTML = '<div class="ik-as__bubble"><span class="ik-as__dots"><i></i><i></i><i></i></span></div>';
    stream.appendChild(wrap);
    stream.scrollTop = stream.scrollHeight;
    pensa = wrap;
  }
  function smettiScrivendo() {
    if (pensa && pensa.parentNode) { pensa.parentNode.removeChild(pensa); }
    pensa = null;
  }

  var NONSO = 'Su questo non ho una risposta certa, e su un alimento preferisco non tirare a indovinare.';

  function chiediAllAi(domanda, contesto) {
    if (!D.ai.endpoint) { return Promise.resolve(null); }
    var ctrl = ('AbortController' in window) ? new AbortController() : null;
    var t = setTimeout(function () { if (ctrl) { ctrl.abort(); } }, 12000);
    return fetch(D.ai.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: ctrl ? ctrl.signal : undefined,
      body: JSON.stringify({ domanda: domanda, contesto: contesto, pagina: location.pathname })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { clearTimeout(t); return (j && (j.risposta || j.answer)) || null; })
      .catch(function () { clearTimeout(t); return null; });
  }

  function contestoPerAi() {
    return {
      spedizione: S,
      prodotto: P ? {
        titolo: P.titolo, prezzo: P.prezzo, disponibile: P.disponibile,
        scadenza: campoProdotto('scadenza').replace(/<[^>]+>/g, ' ').trim(),
        conservazione: campoProdotto('conservazione').replace(/<[^>]+>/g, ' ').trim(),
        preparazione: campoProdotto('preparazione').replace(/<[^>]+>/g, ' ').trim(),
        allergeni: campoProdotto('allergeni').replace(/<[^>]+>/g, ' ').trim()
      } : null,
      risposte: KB.filter(function (v) { return v.body; }).map(function (v) {
        return { domanda: v.q, risposta: v.body.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim() };
      })
    };
  }

  function chiedi(domanda, origine) {
    domanda = (domanda || '').trim();
    if (!domanda) { return; }
    bolla(domanda, true);
    input.value = '';
    input.style.height = 'auto';
    scrivendo();

    /* Si aspettano insieme il carrello e il catalogo: il catalogo arriva
       da una richiesta a parte e senza di lui l'assistente non
       riconoscerebbe i nomi dei piatti. Sono due promesse che non
       falliscono mai, quindi il seguito parte comunque. */
    Promise.all([caricaCarrello(), caricaDati()]).then(function () {
      var r = classifica(domanda);
      var d = decidi(r);
      var top = d.top;
      var risposta = d.risposta;
      var usata = d.usata;

      setTimeout(function () {
        smettiScrivendo();

        if (risposta) {
          var b = bolla(risposta, false);
          fonte(b, usata && usata.src);
          if (usata && usata.hand) { passaggio(domanda); }
          push('assistant_answer', { domanda: domanda, risposta_id: usata ? usata.id : '', punteggio: Math.round((top ? top.s : 0) * 100) / 100, origine: origine || 'scritta' });
          suggerimenti(scegliSeguiti(r, usata));
          return;
        }

        if (!r.qt.length) {
          bolla('<p>Ciao. Dimmi pure: consegna, conservazione, cottura, allergeni, o un piatto in particolare.</p>', false);
          suggerimenti(P
            ? ['Quando mi arriva se ordino adesso?', 'Come si prepara questo piatto?', 'Quali allergeni contiene?']
            : ['Quando mi arriva se ordino adesso?', 'Quanto costa la spedizione?', 'Devo cucinarlo io?']);
          return;
        }

        var quasi = r.voci.filter(function (x) { return x.s >= 0.18 && x.s < 0.34; }).slice(0, 3);
        if (quasi.length) {
          bolla('<p>' + NONSO + ' Forse cercavi una di queste:</p>', false);
          suggerimenti(quasi.map(function (x) { return x.v.q; }));
          passaggio(domanda);
          push('assistant_no_match', { domanda: domanda, tipo: 'parziale' });
          return;
        }

        if (D.ai.endpoint) {
          scrivendo();
          chiediAllAi(domanda, contestoPerAi()).then(function (testo) {
            smettiScrivendo();
            if (testo) {
              var w = document.createElement('div');
              w.className = 'ik-as__msg';
              var bb = document.createElement('div');
              bb.className = 'ik-as__bubble';
              var p1 = document.createElement('p');
              p1.textContent = testo;
              bb.appendChild(p1);
              var nota = document.createElement('span');
              nota.className = 'ik-as__src';
              nota.textContent = D.ai.nota;
              bb.appendChild(nota);
              w.appendChild(bb);
              stream.appendChild(w);
              stream.scrollTop = stream.scrollHeight;
              push('assistant_answer', { domanda: domanda, risposta_id: 'ai', origine: 'ai' });
            } else {
              bolla('<p>' + NONSO + '</p><p>Te lo faccio dire da una persona: ti risponde di solito entro poche ore.</p>', false);
              passaggio(domanda);
              push('assistant_no_match', { domanda: domanda, tipo: 'ai_vuota' });
            }
          });
          return;
        }

        bolla('<p>' + NONSO + '</p><p>Te lo faccio dire da una persona: ti risponde di solito entro poche ore.</p>', false);
        passaggio(domanda);
        push('assistant_no_match', { domanda: domanda, tipo: 'nessuna' });
      }, 260);
    });
  }

  /* ---------------------------------------------------------------
     6. APERTURA, PRIMO MESSAGGIO, TASTIERA
     --------------------------------------------------------------- */

  var avviato = false;

  function apri() {
    root.setAttribute('data-open', '');
    openBtn.setAttribute('aria-expanded', 'true');
    caricaCarrello();
    /* Qui parte il catalogo: e' il momento in cui serve davvero, e la
       richiesta viaggia mentre la persona sta ancora leggendo il saluto. */
    caricaDati();

    if (!avviato) {
      avviato = true;
      var saluto = P
        ? '<p>Ciao. Sto guardando <strong>' + P.titolo + '</strong> insieme a te: posso dirti quando ti arriva, quanto dura, come si scalda e cosa contiene.</p>'
        : '<p>Ciao. Chiedimi quello che ti serve sapere prima di ordinare: consegna, spedizione, conservazione, allergeni.</p>';
      bolla(saluto, false);

      var s = P
        ? ['Quando mi arriva se ordino adesso?', 'Come si prepara questo piatto?', 'Quanto dura questo piatto?', 'Quali allergeni contiene?']
        : ['Quando mi arriva se ordino adesso?', 'Quanto costa la spedizione?', 'Posso congelarlo io quando arriva?', 'Devo cucinarlo io?'];
      suggerimenti(s);
      push('assistant_open', { pagina: location.pathname });
    }

    setTimeout(function () { input.focus(); }, 60);
  }

  function chiudi() {
    root.removeAttribute('data-open');
    openBtn.setAttribute('aria-expanded', 'false');
    openBtn.focus();
  }

  openBtn.addEventListener('click', apri);
  closeBtn.addEventListener('click', chiudi);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.hasAttribute('data-open')) { chiudi(); }
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    chiedi(input.value, 'scritta');
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      chiedi(input.value, 'scritta');
    }
  });

  input.addEventListener('input', function () {
    input.style.height = 'auto';
    input.style.height = Math.min(96, input.scrollHeight) + 'px';
  });

  /* Se c'è già un widget di chat in basso a destra, si sposta sopra. */
  setTimeout(function () {
    var altri = document.querySelector('#shopify-chat, #ShopifyChat, [id^="chat-button-container"], .shopify-chat');
    if (altri) {
      var h = altri.getBoundingClientRect().height || 56;
      root.style.setProperty('--as-bottom', Math.round(h + 26) + 'px');
    }
  }, 2500);

  /* Da qualunque punto del sito: <a href="#ik-assistente"> apre l'assistente. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[href="#ik-assistente"], [data-ik-as-apri]');
    if (!a) { return; }
    e.preventDefault();
    apri();
    var q = a.getAttribute('data-ik-as-domanda');
    if (q) { chiedi(q, 'link'); }
  });
})();